module.exports = __webpack_public_path__ + "static/5-be4d9451e107919913b44b9bf4873971.jpeg";